window.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('cookieman-modal')) {
    import('./_cookieman.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}